import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Facebook, Youtube } from 'lucide-react';
import { CONTACT } from '../data/products';

// Centralised social icon map — reads from CONTACT.socials so URLs update in one place.
const SOCIAL_ICONS = [
  { key: 'instagram', label: 'Instagram', Icon: Instagram },
  { key: 'linkedin',  label: 'LinkedIn',  Icon: Linkedin  },
  { key: 'facebook',  label: 'Facebook',  Icon: Facebook  },
  { key: 'youtube',   label: 'YouTube',   Icon: Youtube   },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#111111] text-white">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 pt-24 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="font-display text-3xl md:text-4xl leading-tight tracking-tight">
              Designed for life.<br />Built for tomorrow.
            </div>
            <div className="mt-8 text-[11px] tracking-[0.32em] uppercase text-white/50">Modularoom™</div>
          </div>
          <div className="md:col-span-2">
            <div className="text-[11px] tracking-[0.28em] uppercase text-white/40 mb-5">Explore</div>
            <ul className="space-y-3 text-sm text-white/85">
              <li><Link to="/products" className="hover:text-[#C7A36A]">Products</Link></li>
              <li><Link to="/applications" className="hover:text-[#C7A36A]">Applications</Link></li>
              <li><Link to="/technology" className="hover:text-[#C7A36A]">Technology</Link></li>
              <li><Link to="/gallery" className="hover:text-[#C7A36A]">Gallery</Link></li>
              <li><Link to="/about" className="hover:text-[#C7A36A]">About</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.28em] uppercase text-white/40 mb-5">Contact</div>
            <div className="text-sm text-white/80 leading-relaxed">
              {CONTACT.address.map((l) => <div key={l}>{l}</div>)}
            </div>
            <div className="mt-4 text-sm">
              <a href={`tel:${CONTACT.phone}`} className="block hover:text-[#C7A36A]">{CONTACT.phone}</a>
              <a href={`mailto:${CONTACT.email}`} className="block text-[#C7A36A]">{CONTACT.email}</a>
            </div>
          </div>
          <div className="md:col-span-2">
            <div className="text-[11px] tracking-[0.28em] uppercase text-white/40 mb-5">Social</div>
            <div className="flex flex-wrap gap-3">
              {SOCIAL_ICONS.filter(({ key }) => CONTACT.socials[key]).map(({ key, label, Icon }) => (
                <a
                  key={key}
                  data-testid={`footer-${key}`}
                  href={CONTACT.socials[key]}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`MODULAROOM on ${label}`}
                  className="p-2 rounded-full border border-white/20 hover:border-[#C7A36A] hover:text-[#C7A36A] transition-colors"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="border-t border-white/10 mt-16 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[12px] text-white/40">
          <div>© {new Date().getFullYear()} Modularoom. All rights reserved.</div>
          <div>Made in India. Delivered worldwide.</div>
        </div>
      </div>
    </footer>
  );
}
